import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import DateSocialShareBody from './DateSocialShareBody';
import DateSocialShareData from './DateSocialShareData';

const Edit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <DateSocialShareBody isEditMode {...props} />

      <SidebarPortal selected={selected}>
        <DateSocialShareData
          key={block}
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};
export default withBlockExtensions(Edit);
